/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const themeData = {
    HD: {
        filledColorBg: '#387154',
        unFilledColorBg: '#ffffff',
        borderFilledColor: '#387154',
        borderUnFilledColor: '#2F2F2F',
        labelFilledColor: '#2F2F2F',
        labelUnFilledColor: '#7B7B7B',
        countFilledColor: '#ffffff',
        countUnFilledColor: '#7B7B7B',
        checkMarkFilledColor: '#2F2F2F',
        checkMarkBgColor: '#E4F3EE',
        progressColorError: '#DF3030',
        progressColorPending: '#E4F3EE',
        progressColorSelected: '#387154',
        buttonColorSelect: '#2F2F2F',
        nextButtonColor: '#ffffff',
        nextButtonBg: '#a1001a',
        previousButtonColor: '#a1001a',
        buttonColorClear: '#2F2F2F',
    },
    CCO: {
        filledColorBg: '#512C1C',
        unFilledColorBg: '#ffffff',
        borderFilledColor: '#512C1C',
        borderUnFilledColor: '#C8E9F1',
        labelFilledColor: '#000000',
        labelUnFilledColor: '#7B7B7B',
        countFilledColor: '#ffffff',
        countUnFilledColor: '#91674A',
        checkMarkFilledColor: '#ffffff',
        checkMarkBgColor: '#91674A',
        progressColorError: '#DF3030',
        progressColorPending: '#C8E9F1',
        progressColorSelected: '#512C1C',
        buttonColorSelect: '#512C1C',
        nextButtonColor: '#ffffff',
        nextButtonBg: '#e80a4d',
        previousButtonColor: '#e80a4d',
        buttonColorClear: '#512C1C',
    },
    VC: {
        filledColorBg: '#CF3D02',
        unFilledColorBg: '#ffffff',
        borderFilledColor: '#CF3D02',
        borderUnFilledColor: '#FAA78B',
        labelFilledColor: '#000000',
        labelUnFilledColor: '#7B7B7B',
        countFilledColor: '#ffffff',
        countUnFilledColor: '#CF3D02',
        checkMarkFilledColor: '#ffffff',
        checkMarkBgColor: '#F76A38',
        progressColorError: '#DF3030',
        progressColorPending: '#E9E9E9',
        progressColorSelected: '#1D773F',
        buttonColorSelect: '#CF3D02',
        nextButtonColor: '#ffffff',
        nextButtonBg: '#CF3D02',
        previousButtonColor: '#CF3D02',
        buttonColorClear: '#2F2F2F',
    },
};

export default themeData;
